import { Box } from '@mui/material'
import { styled as muiStyled } from '@mui/material/styles'

export const QuestionCardStyles = muiStyled(Box)({
    display: 'flex',
    flexDirection: 'column',
    rowGap: 8,
    paddingBottom: 16,
    borderBottom: '1px solid #e0e0e0',
    '&:last-child': {
        borderBottom: 'none',
        paddingBottom: 0,
    },
    '.question-header': {
        display: 'flex',
        alignItems: 'flex-start',
        columnGap: 8,
        fontWeight: 'bold',
        fontSize: 16,
    },
    '.question-number': {
        minWidth: 22,
        height: 22,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 13,
        fontWeight: 'bold',
        flexShrink: 0,
    },
    '.question-text': {
        lineHeight: 1.5,
    },
    '.answers-list': {
        display: 'flex',
        flexDirection: 'column',
        rowGap: 6,
        // paddingRight: 30,
    },
})

export const AnswerOptionStyles = muiStyled(Box, {
    shouldForwardProp: (prop) => prop !== 'correct',
})(({ correct }) => ({

    display: 'flex',
    alignItems: 'center',
    columnGap: 8,
    paddingTop: 6,
    paddingBottom: 6,
    paddingRight: correct ? 25 : 53,
    paddingLeft: correct ? 20 : 10,  // מפצה על ה-margin
    borderRadius: 'var(--S, 4px)',
    background: correct ? 'var(--Info-2-100, #EAF3FF)' : 'transparent', fontSize: 15,
    '.answer-icon': {
        flexShrink: 0,
        color: correct ? '#569AFF' : '#B3BDCB',
    },
    '.answer-text': {
        fontWeight: correct ? 'bold' : 'normal',
        color: correct ? '#325168' : 'inherit',
    },
}))
